import { Button } from "@/components/ui/button";
import { Lock, ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

interface Phase3TransitionProps {
  onContinue: () => void;
  isDisabled?: boolean;
  dominantOptionName?: string;
}

export const Phase3Transition = ({ onContinue, isDisabled, dominantOptionName }: Phase3TransitionProps) => {
  return (
    <div className={cn(
      "rounded-xl border bg-gradient-to-br from-primary/5 to-transparent p-6 transition-all duration-300",
      isDisabled 
        ? "border-border opacity-60" 
        : "border-primary/30 hover:border-primary/50 hover:shadow-lg hover:shadow-primary/5"
    )}>
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="space-y-1">
          <h3 className="text-lg font-semibold">
            {isDisabled ? "Bewertung abschließen" : "Bereit zum Committen"}
          </h3>
          <p className="text-sm text-muted-foreground">
            {dominantOptionName ? (
              <>Commit auf <span className="text-foreground font-medium">{dominantOptionName}</span> um den Report zu erhalten.</>
            ) : (
              <>Löse alle Konflikte, um fortzufahren.</>
            )}
          </p>
        </div>
        
        <Button 
          onClick={onContinue} 
          size="lg" 
          className={cn(
            "gap-2 min-w-[180px] transition-all",
            !isDisabled && "shadow-md hover:shadow-lg"
          )}
          disabled={isDisabled}
        >
          <Lock className="h-4 w-4" />
          Entscheidung committen
          <ArrowRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};
